module.exports = __webpack_public_path__ + "static/media/home.367d3b06.svg";